import { Component, OnDestroy, OnInit } from '@angular/core';

import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';
import { UiSidebarService } from '@ib-core/services/ui-sidebar.service';
import { UiTouchscreenService } from '@ib-core/services/ui-touchscreen.service';
import { AuthFacadeService } from '@ib-core-services/auth-facade.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { AnimateInOutOpacityFromLeft } from '@ib-shared/animations/in-out-opacity-from-left.anim';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'ib-authenticated',
  templateUrl: './authenticated.component.html',
  styleUrls: ['./authenticated.component.scss'],
  animations: [AnimateInOutOpacityFromLeft('100ms')],
})
export class AuthenticatedComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public isSidebarOpen: boolean;
  public authUser$ = this.authFacadeS.selectAuthUser();
  public logout$ = this.authFacadeS.selectIsLogout();
  constructor(
    private authFacadeS: AuthFacadeService,
    public sidebarS: UiSidebarService,
    public tsS: UiTouchscreenService,
    public bpS: UiBreakpointsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.sidebarS
      .selectIsSidebarExpanded()
      .pipe(takeUntil(this.destroy$))
      .subscribe(r => (this.isSidebarOpen = r.v));
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }

  logout(): void {
    this.authFacadeS.logout();
  }

  toggleSidebar(): void {
    this.sidebarS.toggleSidebar();
  }
}
